export class KohtumineTegevus {
    public id: number | undefined = undefined;
    public liik: TegevuseLiik | undefined = undefined;
    public pealkiri: string | undefined = undefined;
    public algusKp: string | undefined = undefined;
    public loppKp: string | undefined = undefined;
    public selgitused: string[] | undefined = undefined;
    public koht: string | undefined = undefined;
    public lisand: string | undefined = undefined;
}

export class KohtumineTegevusTeavitus {
    public id: number | undefined = undefined;
    public liik: TegevuseLiik | undefined = undefined;
    public pealkiri: string | undefined = undefined;
    public algusKp: string | undefined = undefined;
    public loppKp: string | undefined = undefined;
}


export enum TegevuseLiik {
    Teadmata = 0,
    RegistreerimiskohustuseTäitmine = 1,
    VeebipõhineRegistreerimiskohustus = 2,
    TelefonipõhineRegistreerimiskohustus = 3,
    ÜldkasulikTöö = 4,
    ElektroonilineValve = 5,
    ElektroonilineValveKinnitamata = 6,
    HoiveProgramm = 7,
}